class CustomHelper {
  static IsNotFaceBookBrowser() {
    if (!navigator.userAgent.match(/FBAN|FBAV/i)) return true;
    else return false;
  }
}
export default CustomHelper;
